import React, { useState, useEffect } from 'react';
import { Autocomplete, TextField, CircularProgress } from '@mui/material';
import { useDataProvider } from 'src/mtska-frontend-data-provider';
import { useTranslation } from 'react-i18next';

const InputAutocomplete = ({
    dataProvider, searchkey = "name", searchkeys = [], labelkey = "label", filters = {}, project = [], distinct = [],  label = 'Select', onChange = () => { },
    name, invalid, variant = "outlined", placeholder, disabled, readonly, required, startDecorator, endDecorator, multiple = false,
    style, value, size = 'regular', preload = false, ctaText = '', 
    keyvalue // se vuoi che si setti uno specifico valore dell'oggetto recuperato dall'autocomplete, passa su keyvalue la chiave
}) => {
    const { t } = useTranslation();
    const [inputValue, setInputValue] = useState('');
    const { items, loading, loadAll } = useDataProvider(dataProvider);

    // console.info('preload fuori', preload)
    useEffect(() => {
        // if (preload) {
        //     console.info('preload di ', label, dataProvider)
        // }
        if (inputValue.length < 2 && !preload) {
            return;
        }
        const fetch = async () => {
            try {
                const compoundfilters = {};
                const externalfilters = filters?.items ?? [];
                const normalizedSearchKeys = Array.isArray(searchkeys) && searchkeys.length > 0
                    ? searchkeys
                    : [searchkey];
                const searchFilter = normalizedSearchKeys.length > 1
                    ? { field: normalizedSearchKeys, operator: "containsAny", value: inputValue }
                    : { field: normalizedSearchKeys[0], operator: "contains", value: inputValue };

                compoundfilters.items = [...externalfilters, searchFilter];
                compoundfilters.project = project;
                compoundfilters.distinct = distinct;

                loadAll(compoundfilters);
            } catch (e) {
                console.error('Errore nel caricamento dei dati:', e);
            }
        };

        const debounce = setTimeout(fetch, 300);
        return () => clearTimeout(debounce);
    }, [inputValue, preload]);

    const computedOptions = () => {
        return items ?? value ?? null;
    }

    const getSearchKeysLabel = (option) => {
        const keys = Array.isArray(searchkeys) ? searchkeys.filter((key) => typeof key === 'string' && key.length > 0) : [];
        if (keys.length === 0 || typeof option !== 'object' || option === null) {
            return '';
        }

        const [primaryKey, ...otherKeys] = keys;
        const primaryValue = option[primaryKey];
        if (primaryValue === undefined || primaryValue === null || primaryValue === '') {
            return '';
        }

        const extras = otherKeys
            .map((key) => option[key])
            .filter((value) => value !== undefined && value !== null && value !== '');

        if (extras.length === 0) {
            return `${primaryValue}`;
        }

        return `${primaryValue} (${extras.join(', ')})`;
    };

    return (
        <Autocomplete
            multiple={multiple}
            id={name}
            name={name}
            error={invalid}
            onChange={(e, v) => {
                const changedValue = (Array.isArray(v) || (typeof v === 'object' && v !== null)) ? v[keyvalue] ?? v : v;
                //console.info('onChange autocomplete', changedValue)
                onChange(changedValue);
            }}
            variant={variant}
            className="form-element-field form-element-field-autocomplete"
            size={size}

            placeholder={t(placeholder)}
            disabled={disabled}
            readOnly={readonly}
            required={required}

            label={label}
            options={ computedOptions() }
            value={value}

            getOptionLabel={(option) => {
                const searchKeysLabel = getSearchKeysLabel(option);
                if (searchKeysLabel) {
                    return searchKeysLabel;
                }

                if (Array.isArray(labelkey)) {
                    return option[labelkey[0]]+" "+option[labelkey[1]]
                }
                
                return option[labelkey] || '';
            }}
            loading={loading}
            onInputChange={(_, value) => {
                //console.info('onInputChange', _, value)
                setInputValue(value);
            }}
            renderInput={(params) => (
                <TextField
                    {...params}
                    label={label}
                    placeholder={placeholder ? t(placeholder) : t('all')}
                    sx={{
                        '& .MuiInputBase-input::placeholder': {
                            color: 'inherit',
                            opacity: 1,
                        },
                    }}
                    InputLabelProps={{
                        ...params.InputLabelProps,
                        shrink: true,
                    }}
                    InputProps={{
                        ...params.InputProps,
                        startAdornment: (
                            <>
                                {startDecorator ?? null}
                                {params.InputProps.startAdornment}
                            </>
                        ),
                        endAdornment: (
                            <>
                                {endDecorator ?? null}
                                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                {params.InputProps.endAdornment}
                            </>
                        ),
                    }}
                />
            )}
            sx={style}
            noOptionsText={inputValue === '' ? (ctaText ? ctaText : t('Type to search')) : t('No options found')}
        />
    );
}

export default InputAutocomplete;